// Generated by scripts/generate-public-surface.ts. Do not edit.

import type {
  CountryValidator,
  ParsedPersonId,
} from "../../types";

import { createValidator } from "#stdnum-runtime";

const iin: CountryValidator<"KZ", ParsedPersonId> =
  createValidator("kz.iin", 112);

export default iin;
export const compact = iin.compact;
export const format = iin.format;
export const validate = iin.validate;
export const generate = (): string =>
  iin.generate?.() ??
  (() => {
    throw new Error(
      "Validator kz.iin cannot generate values",
    );
  })();
export const parse = iin.parse;
